function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 14.8938H22.2141V30.7516C22.2141 30.9579 22.3828 31.1266 22.5891 31.1266H25.4016C25.6078 31.1266 25.7766 30.9579 25.7766 30.7516V14.8938H29.25C29.5641 14.8938 29.7375 14.5329 29.5453 14.2891L24.2953 7.64223C24.2602 7.59741 24.2154 7.56117 24.1642 7.53624C24.1131 7.51131 24.0569 7.49835 24 7.49835C23.9431 7.49835 23.8869 7.51131 23.8358 7.53624C23.7846 7.56117 23.7398 7.59741 23.7047 7.64223L18.4547 14.2844C18.2625 14.5329 18.4359 14.8938 18.75 14.8938ZM41.1562 29.3454H38.3438C38.1375 29.3454 37.9688 29.5141 37.9688 29.7204V36.9391H10.0312V29.7204C10.0312 29.5141 9.8625 29.3454 9.65625 29.3454H6.84375C6.6375 29.3454 6.46875 29.5141 6.46875 29.7204V39.0016C6.46875 39.8313 7.13906 40.5016 7.96875 40.5016H40.0312C40.8609 40.5016 41.5312 39.8313 41.5312 39.0016V29.7204C41.5312 29.5141 41.3625 29.3454 41.1562 29.3454Z",
  fill: "#15A9E1"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.f1d8aadc.svg";
export { ForwardRef as ReactComponent };